import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const login = async (credentials) => {
  return api.post("/login", credentials);
};

export const VendorRegisterSelf = async (infoData) => {
  return api.post("/registerVendorSelf", infoData);
};

export const getAllClients = async () => {
  const config = await getAuthConfig();
  return api.get("/getAllClients", config);
};

export const ResetPassword = async (credentials) => {
    const config = await getAuthConfig();
  return api.post("/change-password", credentials, config);
};